import { Box, Grid, Typography } from '@mui/material';
import moment from 'moment';
import React from 'react';
import NoDataImg from '../../../../../Components/NoDataFound/NoDataFound';
import Skeleton from 'react-loading-skeleton';
import { Chip } from '@mui/material';
import { styled } from '@mui/system';
const TransactionCard = styled(Box)(({ theme }) => ({
    width: '100%',
    background: "#FAFAFA",
    border: "1px solid #08557F33",
    padding: '15px',
    borderRadius: '15px',
    marginBottom: '15px',
    '&:hover': {
        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
    },
}));

const CoinTransaction = (props) => {
    const { coinTransactionList, isLoading } = props;
    const getStatusLabel = (status) => {
        switch (status) {
            case 1: return 'Completed';
            default: return 'Unknown';
        }
    };

    const getTypeLabel = (type) => {
        switch (type) {
            case 1: return 'Credit';
            case 2: return 'Debit';
            default: return 'Other';
        }
    };

    const getOperationLabel = (operation) => {
        switch (operation) {
            case 1: return 'System';
            case 2: return 'Manual';
            case 3: return 'Platform';
            default: return 'Other';
        }
    };

    return (
        <Box sx={{
            width: '100%',
            padding: '0px 10px 0px 10px',
            height: 'calc(100vh - 210px)',
            overflowY: 'auto',
        }}>
            <Grid container spacing={2} height={
                coinTransactionList && coinTransactionList?.length > 0 ? "auto" : "100%"
            }>
                {isLoading ? (
                    [...Array(5)].map((_, index) => (
                        <Grid item xs={12} key={index}>
                            <Skeleton variant="rectangular" height={120} borderRadius={15} />
                        </Grid>
                    ))
                ) : coinTransactionList?.length > 0 ? coinTransactionList?.map((transaction, index) => {
                    return (
                        <Grid item xs={12} key={index}>
                            <TransactionCard>
                                <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                                    <Typography
                                        sx={{
                                            fontSize: "16px",
                                            fontWeight: "300",
                                            color: "rgba(40, 29, 27, 1)",
                                            textAlign: "left",
                                            width: "100%",
                                            fontFamily: "Outfit",
                                            fontWeight: '600'
                                        }}
                                    >
                                        {transaction.message}
                                    </Typography>
                                    <Chip
                                        label={getTypeLabel(transaction.type)}
                                        color={transaction.type === 1 ? 'success' : 'error'}
                                        size="small"
                                    />
                                </Box>

                                <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                                    <Typography sx={{
                                        fontSize: "14px",
                                        fontWeight: "500",
                                        color: "rgba(8, 85, 127, 1)",
                                        textAlign: "left",
                                        textTransform: "capitalize",
                                        fontFamily: "Outfit"
                                    }}>
                                        {moment(transaction.created_at).format('DD MMM YYYY, hh:mm A')}
                                    </Typography>
                                    <Typography variant="body1" fontWeight="bold">
                                        {transaction.coin} coins
                                    </Typography>
                                </Box>

                                <Box display="flex" justifyContent="space-between" alignItems="center">
                                    <Box>
                                        <Chip
                                            label={getOperationLabel(transaction.operation)}
                                            variant="outlined"
                                            size="small"
                                        />
                                        {/* {transaction.admin_note && (
                                            <Typography variant="caption" color="text.secondary" ml={1}>
                                                {transaction.admin_note}
                                            </Typography>
                                        )} */}
                                    </Box>
                                    <Chip
                                        label={getStatusLabel(transaction.status)}
                                        color="primary"
                                        size="small"
                                    />
                                </Box>
                            </TransactionCard>
                        </Grid>
                    )
                }) : (
                    <Grid item xs={12} sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                    }}>
                        <NoDataImg />
                    </Grid>
                )}
            </Grid>
        </Box>
    );
};

export default CoinTransaction;